var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    _c("div", { staticClass: "row dashboard-first-row" }, [
      _c("div", { staticClass: "col-12 col-lg-4" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12", lg: "12", xl: "12" } },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-white",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("i", { staticClass: "fas fa-search mr-2" }),
                              _vm._v("Find/Start A New Quote\n                ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card-body",
                            { staticClass: "ml-2 mr-2" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "px-0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center mx-auto my-3 w-100"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert alert-warning  w-100",
                                              attrs: { role: "note" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row no-gutters"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-inline-block pr-2"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          width: "20px",
                                                          height: "20px",
                                                          src: require("../../../assets/exclamation-circle-yellow-new.svg"),
                                                          alt: "info"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col d-inline-block my-auto smaller-font-content"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mb-0 text-dark-gray"
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              "Prior to gathering information from the customer, please read the following statement:"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            '"I’ll be submitting your information to insurance carriers I represent who will provide you with a notice describing their privacy policies and practices once an insurance policy has been established."'
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "emailorPhone" } },
                                            [_vm._v("Email or Phone Number")]
                                          ),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            ref: "emailorPhone",
                                            staticClass: "col-md-10",
                                            attrs: {
                                              name: "emailorPhone",
                                              type: "text",
                                              id: "emailorPhone",
                                              placeholder:
                                                "Email Address/ Phone Number"
                                            },
                                            model: {
                                              value: _vm.formData.ep,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ep",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "formData.ep"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "emailorPhone"
                                                  ),
                                                  expression:
                                                    "errors.has('emailorPhone')"
                                                }
                                              ],
                                              staticClass: "text-danger"
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "emailorPhone"
                                                    )
                                                  ) +
                                                  "\n                          "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "px-0" },
                                    [
                                      _c(
                                        "b-form-group",
                                        [
                                          _c("input-product-type", {
                                            attrs: {
                                              insuranceType: _vm.insuranceType
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "px-0" },
                                    [
                                      _c("b-form-group", [
                                        _c(
                                          "label",
                                          { attrs: { for: "zipcode" } },
                                          [
                                            _vm._v("Zip Code"),
                                            _c(
                                              "span",
                                              { staticClass: "star" },
                                              [_vm._v("*")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group",
                                            staticStyle: {
                                              width: "35%",
                                              "max-width": "100%"
                                            }
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "digits:5",
                                                  expression: "'digits:5'"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.formData.zip,
                                                  expression: "formData.zip"
                                                },
                                                {
                                                  name: "mask",
                                                  rawName: "v-mask",
                                                  value: "#####",
                                                  expression: "'#####'"
                                                }
                                              ],
                                              ref: "zipcode",
                                              staticClass:
                                                "std-width form-control",
                                              class: {
                                                "form-control": true,
                                                error: _vm.errors.has("zipcode")
                                              },
                                              attrs: {
                                                name: "zipcode",
                                                id: "zipcode",
                                                type: "text",
                                                maxlength: "5",
                                                size: "5"
                                              },
                                              domProps: {
                                                value: _vm.formData.zip
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "zip",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              class: {
                                                "fas fa-exclamation-triangle": _vm.errors.has(
                                                  "zipcode"
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "zipcode"
                                                ),
                                                expression:
                                                  "errors.has('zipcode')"
                                              }
                                            ],
                                            staticClass: "text-danger"
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.errors.first("zipcode")
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "mt-1" }, [
                                          _c(
                                            "span",
                                            { staticClass: "qrp-text-muted" },
                                            [
                                              _vm._v("("),
                                              _c(
                                                "span",
                                                { staticClass: "star" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(
                                                "Required for new quotes.)"
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-row", [
                                _vm.errorMessage
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 mb-2 px-0 text-notice error-red"
                                      },
                                      [
                                        _c("span", [
                                          _c("strong", [_vm._v("Required:")]),
                                          _vm._v(" " + _vm._s(_vm.errorMessage))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "px-0" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            type: "submit",
                                            variant: "btn btn-primary"
                                          },
                                          on: { click: _vm.searchResult }
                                        },
                                        [_vm._v("Find Quote")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            type: "button",
                                            variant: "btn btn-outline-primary"
                                          },
                                          on: { click: _vm.newQuote }
                                        },
                                        [_vm._v("New Quote")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-8" },
        [
          _c(
            "b-card",
            { class: _vm.widgetClasses(_vm.recentQuotesReportInfo) },
            [
              _c("dashboard-widget", {
                attrs: {
                  widgetType: "list",
                  widgetData: _vm.recentQuotesReport,
                  widgetInfo: _vm.recentQuotesReportInfo,
                  chartDateFiltersPrimary: _vm.recentQuotesDateFilters
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row dashboard-second-row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-lg-6" },
        [
          _c(
            "b-card",
            { class: _vm.widgetClasses(_vm.stateReportInfo) },
            [
              _c("dashboard-widget", {
                attrs: {
                  widgetType: "report",
                  widgetData: _vm.stateReport,
                  widgetInfo: _vm.stateReportInfo,
                  chartDateFiltersPrimary: _vm.stateDateFilters,
                  productFilters: _vm.stateProductFilters
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-6" },
        [
          _c(
            "b-card",
            { class: _vm.widgetClasses(_vm.agentReportInfo) },
            [
              _c("dashboard-widget", {
                attrs: {
                  widgetType: "report",
                  widgetData: _vm.agentReport,
                  widgetInfo: _vm.agentReportInfo,
                  chartDateFiltersPrimary: _vm.agentDateFilters,
                  productFilters: _vm.agentProductFilters
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row dashboard-third-row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-lg-6" },
        [
          _c(
            "b-card",
            { class: _vm.widgetClasses(_vm.carrierReportInfo) },
            [
              _c("dashboard-widget", {
                attrs: {
                  widgetType: "chart",
                  widgetData: _vm.carrierReport,
                  widgetInfo: _vm.carrierReportInfo,
                  chartDateFiltersPrimary: _vm.carrierDateFilters,
                  productFilters: _vm.carrierProductFilters
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-6" },
        [
          _c(
            "b-card",
            { class: _vm.widgetClasses(_vm.carrierSalesReportInfo) },
            [
              _c("dashboard-widget", {
                attrs: {
                  widgetType: "chart",
                  widgetData: _vm.carrierSalesReport,
                  widgetInfo: _vm.carrierSalesReportInfo,
                  chartDateFiltersPrimary: _vm.carrierSalesDateFilters,
                  productFilters: _vm.carrierSalesProductFilters
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-6" },
        [
          _c(
            "b-card",
            { class: _vm.widgetClasses(_vm.productSalesReportInfo) },
            [
              _c("dashboard-widget", {
                attrs: {
                  widgetType: "chart",
                  widgetData: _vm.productSalesReport,
                  widgetInfo: _vm.productSalesReportInfo,
                  chartDateFiltersPrimary: _vm.productSalesDateFilters
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e2fb2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e2fb2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/dashboard/Dashboard.vue
// module id = null
// module chunks = 